// Import mock entities (for entities not yet in backend)
import {
  Provider as MockProvider,
  Transaction as MockTransaction,
  WebhookLog as MockWebhookLog,
  RoutingRule as MockRoutingRule,
  AuditLog as MockAuditLog,
} from './mockEntities';

// Import real entities (from backend GraphQL API)
import {
  Merchant as RealMerchant,
  Reseller as RealReseller,
  Engine as RealEngine,
  Admin as RealAdmin,
} from './mockEntities';

// Import real Settlement service
import * as settlementService from './services/settlementService';

// Import auth
import { auth } from './graphqlClient';

// Export mock entities
export const Provider = MockProvider;
export const Transaction = MockTransaction;
export const WebhookLog = MockWebhookLog;
export const RoutingRule = MockRoutingRule;
export const AuditLog = MockAuditLog;

// Export real Settlement entity (backed by GraphQL API)
// Wraps the service functions with the same interface expected by the page:
// Settlement.list()   → returns Settlement[]
// Settlement.create() → creates a settlement
// Settlement.update() → updates (status / notes)
export const Settlement = {
  /**
   * Fetch all settlements (returns just the data array for backwards-compat).
   * @param {string} _sortBy  - ignored (backend sorts by createdAt desc)
   * @param {number} limit    - max records (default 200)
   */
  list: (_sortBy = '-created_date', limit = 200) =>
    settlementService
      .getSettlements({ page: 1, limit })
      .then((res) => res?.data ?? []),

  /** Get a single settlement by id */
  get: (id) => settlementService.getSettlementById(id),

  /** Create a new settlement (input matches CreateSettlementInput) */
  create: (input) => settlementService.createSettlement(input),

  /** Update a settlement by id */
  update: (id, input) => settlementService.updateSettlement(id, input),

  /** Process a PENDING → PROCESSING */
  process: (id) => settlementService.processSettlement(id),

  /** Complete a PROCESSING → COMPLETED */
  complete: (id) => settlementService.completeSettlement(id),

  /** Delete a PENDING settlement */
  delete: (id) => settlementService.deleteSettlement(id),
};

// Export real entities
export const Merchant = RealMerchant;
export const Reseller = RealReseller;
export const Engine = RealEngine;
export const Admin = RealAdmin;

// Export auth as User for backward compatibility
export const User = auth;